import { useGetProjectQuery } from '@verantos-dev/data-access-projects';

import { useCohortProfileQuery } from './api/useCohortProfileQuery';
import { useSafeRouteParams } from './useSafeRouteParams';

export const useCohortBuilderData = () => {
  const { projectId, cohortId, cohortVersionId } = useSafeRouteParams();

  const {
    data: projectData,
    error: projectError,
    isSuccess: isProjectSuccess,
  } = useGetProjectQuery(projectId || '', { skip: !projectId });
  const { data: cohort, isSuccess: isCohortSuccess } = useCohortProfileQuery({
    projectId: projectId || '',
    cohortId: cohortId || '',
  });

  return {
    projectId,
    cohortId,
    cohortVersionId,
    latestCohortVersionId: cohort?.latestCohortVersionId,
    // Preserve the existing { data: { data: Cohort-shaped } } envelope so
    // RTK Query consumers of useCohortBuilderData keep working until they
    // migrate. Will narrow to `cohort` directly in a follow-up cleanup.
    data: cohort
      ? {
          data: {
            cohortId: cohort.cohortId,
            cohortName: cohort.cohortName,
            cohortDescription: cohort.cohortDescription,
            latestStatus: cohort.latestStatus,
            latestCohortVersionId: cohort.latestCohortVersionId,
            latestSubjectCount: cohort.latestSubjectCount,
            latestDatasetReleaseId: cohort.latestDatasetReleaseId,
            latestDatasetReleaseDisplayName: cohort.latestDatasetReleaseDisplayName,
            createdBy: {
              userId: cohort.createdByUserId,
              firstName: cohort.createdByFirstName,
              lastName: cohort.createdByLastName,
            },
          },
        }
      : undefined,
    isCohortSuccess,
    projectData,
    projectError,
    isProjectSuccess,
  };
};
